import { Injectable } from '@angular/core';
import MarkdownIt from 'markdown-it';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class MarkdownService {
  private md: MarkdownIt;

  constructor(private sanitizer: DomSanitizer) {
    // Initialize markdown-it with options
    this.md = new MarkdownIt({
      html: true,        // Enable HTML tags in source
      breaks: true,      // Convert '\n' in paragraphs into <br>
      linkify: true,     // Autoconvert URL-like text to links
      typographer: true, // Enable some language-neutral replacement + quotes beautification
    });
  }

  /**
   * Render markdown string to HTML and sanitize it
   */
  render(content: string): SafeHtml {
    if (!content) return this.sanitizer.bypassSecurityTrustHtml('');
    
    // Handle specific case for "Loading..." or "..." to show as-is
    if (content === 'Loading...' || content === '...') {
      return this.sanitizer.bypassSecurityTrustHtml(content);
    }

    // Render markdown to HTML and sanitize it
    const html = this.md.render(content);
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
} 